import { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import { Cart } from "@/graphql/generated";
import { isMainMatic, isRefKit } from "@/utils/ShopifyHelpers";
import mixpanel from "mixpanel-browser";

export const removeItem = ({ set, get }: CartStateGetSet) => {
  return async (lineId: string) => {
    const { cartId, cart: currentCart } = get();
    if (!cartId) {
      console.warn(
        "Attempted to remove item from cart, but cartId is undefined"
      );
      return;
    }

    const isLineIdMatic = currentCart?.lines?.edges?.some(({ node }) => node.id === lineId && isMainMatic(node));
    const isRefkitInCart = currentCart?.lines?.edges?.some(({ node }) => isRefKit(node));
    const refkitLineId = currentCart?.lines?.edges?.find(({ node }) => isRefKit(node))?.node.id;

    let lineIdsToRemove = [lineId];
    if (isLineIdMatic && isRefkitInCart && refkitLineId) {
      lineIdsToRemove.push(refkitLineId);
    }

    const variantId = currentCart?.lines?.edges?.find(({ node }) => node.id === lineId)?.node.merchandise.id;
    mixpanel.track("remove_item", { lineId, variantId, cartId });

    const { cartLinesRemove } = await GRAPHQL_CLIENT.RemoveFromCart({
      cartId,
      lineIds: lineIdsToRemove,
    });
    const cart = cartLinesRemove?.cart as Cart;
    if (!cart) throw new Error("cartLinesRemove failed");


    set({
      cartId: cart.id,
      cart: cart,
    });
  };
};
